import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Box, Button, Divider, Grid, IconButton, Typography } from "@mui/material";
import Card from "../../components/card/Card";
import ButtonContainer from "../../components/buttonContainer";
import InputFields from "../../components/InputFields";
import SelectFields from "../../components/SelectFields";
import userProfile from '../../assets/userProfile.png'
// import './users.scss'
import ActionButton from "../../components/actionButton";
import { ProfilePhoto } from "../../components/profilePhoto/profilePhoto";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userRole } from "../../utils/lists";
import { createUser, updateUser } from "../../store/actions/user";
import { getCities, getStates } from "../../store/actions/address";
import { setDataObject } from "../../utils/Utils";
import SaveButton from "../../components/saveButton/saveButton";
import { createRecord, updateRecord } from "../../store/reducers/user-slice";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { companySetup, updateCompanySetup } from "../../store/actions/auth";

const SetupForm = (props) => {
    const { data, setOpen } = props
    const dispatch = useDispatch();
    const { companyList, wearhouseList, pharmacyList } = useSelector(state => state.filler)
    const { user } = useSelector(state => state.auth)
    const [isLoading, setIsLoading] = useState(false)

    const { countries } = useSelector(state => state.address)

    const [showPassword, setShowPassword] = React.useState(false);

    const [state, setState] = useState([])
    const [city, setCity] = useState([])

    const defaultValues = useForm({
        defaultValues: {
            ID: "",
            EmailAddress: "",
            Threshold: "",
        },
    });

    const {
        control,
        handleSubmit,
        setError,
        clearErrors,
        watch,
        reset,
        resetField,
        setValue,
        getValues,
        formState: { errors },
    } = defaultValues;

    useEffect(() => {
        let data = {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "GETCOMPANYSETUP",
            "data": {},
            "debug": null,
            "token": null
        }
        dispatch(companySetup(data)).then(res => {
            const data = res.payload[0]
            reset({
                ID: data.id || "",
                EmailAddress: data.email || "",
                Threshold: data.threshold || "",
            });
        })
    }, [])

    const submit = () => {
        setIsLoading(true)
        let data = {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "UPDATECOMPANYSETUP",
            "data": {
                ID: watch('ID'),
                EmailAddress: watch('EmailAddress'),
                Threshold: watch('Threshold'),
                EditBy: watch('ID')
            },
            "debug": null,
            "token": null
        }
        console.log(data)
        dispatch(updateCompanySetup(data)).then(res => {
            const data = res.payload
            console.log(data)
            setIsLoading(false)
        })
    }


    return <Card style={{ flex: 1, }}>
        <Box className="usersFormContainer">
            <form>
                {/* <Typography variant='h3' >Profile picture upload</Typography>
                <Box className='usersProfileContainer'>
                    <ProfilePhoto image={userProfile} />
                    <ActionButton label={'Upload Users Photo'} />
                </Box> */}
                <Grid container spacing={1}>
                    <Grid item xs={12} >
                        <Typography variant='h3' >Company Setup</Typography>
                    </Grid>
                    <Grid item xs={6} >
                        <InputFields
                            fieldName="EmailAddress"
                            type="text"
                            label="Email Address"
                            control={control}
                            rules={{
                                required: "Email Address is required",
                            }}
                            error={errors?.EmailAddress}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <InputFields
                            fieldName="Threshold"
                            type="number"
                            label="Threshold"
                            control={control}
                            rules={{
                                required: "Threshold is required",
                            }}
                            error={errors?.Threshold}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <ButtonContainer isSingle>
                            <SaveButton isLoading={isLoading} onClick={handleSubmit(submit)} title={'Save'} />
                        </ButtonContainer>
                    </Grid>
                </Grid>
            </form>
        </Box>
    </Card>
};

export default SetupForm;
